import { format } from 'date-fns';
import { CommonUtilities } from '../../commonUtils';

export default class contractServices {

    static ContractListing(data: any) {
        var url = 'royalty/contractList';

        return CommonUtilities.postData(url, data);
    }

    static contractIndicators(data: any) {
        var periodSummary = {
            contractRefNum: data.contractRefNum,
            periodFrom: data.periodNum
        }
        var url = 'contracts/indicators/periodSummaryBalance';
        return CommonUtilities.postData(url, { periodSummary });
    }

    static contractIndicator(data: any) {
        var url = 'contracts/indicator';
        return CommonUtilities.postData(url, data);
    }

    static contractIndicatorChart(data: any) {
        var url = 'contracts/Balance/' + data.contractRefNum + '/chart?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static contractIndicatorExport(data: any, fileName: any) {
        var url = 'contracts/indicator?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', fileName);
    }


    //search for a contracts
    static contractSelection(data: any) {
        var url = 'affiliate/contractsListAffiliate';
        return CommonUtilities.postData(url, data);
    }

    //add a contract to user
    static addUserContracts(data: any) {
        var url = 'affiliate/selection/updateContractsForAffiliateUser';
        return CommonUtilities.postData(url, data);
    }

    //delete contract from a user - unlinked
    static deleteUserContract(data: any) {
        var url = 'affiliate/affiliateContract/' + data.contractRefNums + '/user/' + data.userEmails;
        return CommonUtilities.deleteData(url);
    }

    //https://staging1.onkorrect.com/Api/contacts/788/getContactsByContractRefNum
    static getContactsByContractRefNum(data: any) {
        var url = 'contacts/' + data.contractRefNum + '/getContactsByContractRefNum';
        return CommonUtilities.getData(url);
    }

    //https://qa.onkorrect.com/Api/contracts/overview/101?contractRefNum=101
    static overview(data: any) {
        var url = 'contracts/overview/' + data.contractRefNum + '?contractRefNum=' + data.contractRefNum;
        return CommonUtilities.getData(url);
    }

    //https://staging.onkorrect.com/Api/contract/contractDocument/list?pageNumber=1&pageSize=5&ContractRefNum=788
    static contractDocument(data: any) {
        var url = 'contract/contractDocument/list?' + 'pageNumber=1' + '&pageSize=5' + '&ContractRefNum=' + data.contractDetails.contractRefNum;
        return CommonUtilities.getData(url);
    }

    static contractRatesBasis(data: any) {
        var url = 'contracts/' + data.contractRefNum + '/ratesBasis';
        return CommonUtilities.getData(url);
    }

    static contractRecoupables(data: any) {
        var url = 'contracts/' + data.contractRefNum + '/allowableCostLinks';
        return CommonUtilities.getData(url);
    }

    static contractNote(data: any) {
        var url = 'contracts/getContractNotes?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static contractNoteSave(data: any) {
        var url = 'contracts/saveContractNote'
        return CommonUtilities.postData(url, data);
    }

    static contractNoteDelete(data: any) {
        var url = 'contracts/deleteContractNotes/' + data
        return CommonUtilities.deleteData(url);
    }

    static getSelectUnselectAll(data: any) {
        var url = 'affiliate/Affiliate/AffiliateContractSelection';
        return CommonUtilities.postData(url, data);
    }


    //https://staging.onkorrect.com/Api/contracts/27860
    static contractAdditional(data: any) {

        var url = 'contracts/' + data.contractRefNum;
        return CommonUtilities.getData(url);
    }

    //https://staging.onkorrect.com/Api/contracts/gridupdate
    static updateContractStatus(data: any) {

        var url = 'contracts/gridupdate';

        return CommonUtilities.postData(url, data);
    }

    static downloadNewReport(data: any, reportType: any) {
        var url = '/CrystalReport/' + data;
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', reportType);
    };

    //https://qa.onkorrect.com/Api/contracts/generateContractRefNum
    static generateContractRefNum() {
        var url = 'contracts/generateContractRefNum';
        return CommonUtilities.getData(url);
    }

    //https://qa.onkorrect.com/Api/contracts/systemRegions/
    static systemRegions() {
        var url = 'contracts/systemRegions/';
        return CommonUtilities.getData(url);
    }

    //https://qa.onkorrect.com/Api/contracts/territoryCode/
    static territoryCode() {
        var url = 'contracts/territoryCode/';
        return CommonUtilities.getData(url);
    }

    //https://staging.onkorrect.com/Api/contracts/countContractTemplate
    static countContractTemplate() {
        var url = 'contracts/countContractTemplate';
        return CommonUtilities.getData(url);
    }

    static ContractReportingList(data: any) {
        var url = 'ContractReporting/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

   static reportList(data: any) {
        var url = 'reports/type1,type4,type6?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }


    static ContractTemplateList(data: any) {
        var url = 'contracts/list?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static contractsregionsTerritories(data: any) {
        var url = 'contracts/regionsTerritories/?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getContractTerritory(data: any) {
        var url = 'contracts/getContractTerritory/?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static getMainContractsListing(contract: any) {
        var url = 'contracts/' + contract + '/getMainContracts';
        return CommonUtilities.getData(url);
    }

    static getThirdPartyContractsListing(contract: any) {
        var url = 'contracts/' + contract + '/getThirdPartyContracts';
        return CommonUtilities.getData(url);
    }

    static contractLinked(data: any) {
        var url = 'contracts/compilation/tracks/link?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static contractUnLinked(data: any) {
        var url = 'contracts/compilation/tracks/notLink?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static otherContractLinked(data: any) {
        var url = 'contracts/compilation/tracks/otherContract?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static Contracttracksrelease(data: any) {
        var url = 'contracts/compilation/tracks/release?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }


    static ContractassociatedSongs(data: any) {
        var url = 'publishing/song/associatedSongs/link?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }


    static ContractassociatedSongsnotLink(data: any) {
        var url = 'publishing/song/associatedSongs/notLink?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static ContractassociatedSongsotherContract(data: any) {
        var url = 'publishing/song/associatedSongs/otherContract?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static ContractassociatedSongsrelease(data: any) {
        var url = 'publishing/song/associatedSongs/release?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static ContractUnlinkTrack(contract: any, data: any) {
        var url = 'contracts/compilation/tracks/' + contract + '/unLink';
        return CommonUtilities.postData(url, data);
    }

    static linkTrackToContract(contract: any, data: any) {
        var url = 'contracts/compilation/linkTrackToContract/' + contract;
        return CommonUtilities.postData(url, data);
    }

    static linkReleaseToContract(contract: any, data: any) {
        var url = 'contracts/compilation/linkReleaseToContract/' + contract;
        return CommonUtilities.postData(url, data);
    }


    static ContractUnlinkSong(contract: any, data: any) {
        var url = 'publishing/song/associatedSongs/' + contract + '/unLink';
        return CommonUtilities.postData(url, data);
    }

    static linkSongToContract(contract: any, data: any) {
        var url = 'publishing/song/associatedSongs/linkSongToContract/' + contract;
        return CommonUtilities.postData(url, data);
    }

    static linkReleaseSongToContract(contract: any, data: any) {
        var url = 'publishing/song/associatedSongs/linkReleaseSongToContract/' + contract;
        return CommonUtilities.postData(url, data);
    }

    static listingBySongRef(data: any) {
        var url = 'publishing/songsSubAsset/listingBySongRef?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }


    static associatedSongsSearch(contract: any, data: any) {
        var url = 'publishing/song/associatedSongsSearch/subAsset/' + contract + '?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static kontacts_IPISearch(data: any) {
        var url = 'Contract/kontacts_IPI/subAsset/IPI?' + CommonUtilities.buildQueryString(data, true, true);
        return CommonUtilities.getData(url);
    }

    static genericAPIListing(param: any) {
        var url = 'common/genericListing';
        return CommonUtilities.postData(url, param)
    }

    static periodCount(param: any) {
        var url = 'common/periodCount?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url)
    }

    static publishingSplitsTrackContractListing(param: any) {
        var url = 'contracts/publishingSplitsTrack/Contract?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url)
    }

    static publishingSplitsTrackContractCount(param: any) {
        var url = 'contracts/publishingSplitsTrack/Contract/Count?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.getData(url)
    }

    static excelGeneric(param: any) {
        var url = 'CrystalReport/excelGeneric/export?' + CommonUtilities.buildQueryString(param, true, true);
        return CommonUtilities.exportWithToken('GET', url, {}, '_blank', 'excelGenericExport');
    }

}